import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import { useAppDispatch, useAppSelector } from "common/hooks";
import { Editor } from "@monaco-editor/react";
import { setJson } from "store/slices/nodes";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { toast } from "react-toastify";

export default function JsonEditor() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { json } = useAppSelector((state) => state.nodes);
  const [jsonValue, setJsonValue] = useState<any>(() => JSON.stringify(json, null, 2));
  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    setJsonValue(JSON.stringify(json, null, 2));
  }, [json]);

  const handleDrop = (event: any) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setIsDragging(false);
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setJsonValue(e.target.result);
      };
      reader.readAsText(file);
    } else {
      toast.error("Please drop a valid JSON file.");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    try {
      dispatch(
        setJson(
          JSON.parse(
            jsonValue ||
              JSON.stringify({
                nodes: [],
                edges: [],
                viewport: {
                  x: 540.0259415913994,
                  y: 294.4550148930189,
                  zoom: 0.5,
                },
              })
          )
        )
      );
      setOpen(false);
      toast.success("JSON saved successfully!");
    } catch (error) {
      toast.error("Invalid JSON");
    }
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
    isDragging || setIsDragging(true);
  };

  return (
    <React.Fragment>
      <Tooltip title="JSON">
        <IconButton onClick={handleClickOpen} sx={{ border: 1, borderColor: "#ececec" }}>
          <IntegrationInstructionsOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        onClose={handleClose}
        component="form"
        onSubmit={handleSubmit}
      >
        <DialogTitle>
          JSON Preview
          <Typography variant="body1" color="textSecondary">
            Drag & Drop a JSON file or paste your JSON below
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box onDragOver={handleDragOver} onDrop={handleDrop} sx={{ position: "relative" }}>
            <Box
              sx={{
                inset: 0,
                position: "absolute",
                border: `2px dashed #1976d2`,
                borderRadius: "8px",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#ffffff20",
                backdropFilter: "blur(20px)",
                transition: " 0.3s ",
                zIndex: 9,
                p: 2,
                display: isDragging ? "flex" : "none",
              }}
            >
              <Typography variant="h3">📄 Drop .json file here</Typography>
              <Typography color="textDisabled">or</Typography>
              <Button onClick={() => setIsDragging(false)}>Cancle Drop</Button>
            </Box>

            <Editor
              height="calc(100vh - 230px)"
              defaultLanguage="json"
              value={jsonValue}
              onChange={(value) => setJsonValue(value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
